import { jsx as _jsx } from "react/jsx-runtime";
import { Calendar } from "@faire/web--source/slate/icons/foundation/Calendar";
import { Exclusivity } from "@faire/web--source/slate/icons/foundation/Exclusivity";
import { Global } from "@faire/web--source/slate/icons/foundation/Global";
import { Returns } from "@faire/web--source/slate/icons/foundation/Returns";
import { Shipping } from "@faire/web--source/slate/icons/foundation/Shipping";
export var getShippingDetailsInfoTextIcon = function(infoText) {
    switch(infoText){
        case "SHIPS_FROM":
            return /*#__PURE__*/ _jsx(Global, {});
        case "FIRST_ORDER_PROMO":
        case "FREE_RETURNS_ON_FIRST_ORDER":
            return /*#__PURE__*/ _jsx(Returns, {});
        case "EXCLUSIVITY_AVAILABLE":
        case "EXCLUSIVITY_ACTIVE":
            return /*#__PURE__*/ _jsx(Exclusivity, {});
        case "FULFILLMENT_TIME_CUSTOM":
        case "GET_IT_BY":
            return /*#__PURE__*/ _jsx(Calendar, {});
        case "GUARANTEED_FREE_SHIPPING_THRESHOLD":
            return /*#__PURE__*/ _jsx(Shipping, {});
        default:
            return null;
    }
};
